<template>
  <div>
    <div class="window-sizer mx-auto">
      <div style="max-width: 950px;" class="mx-auto">
        <div>
          <div>
            <img class="login-logo" src="../assets/logo_full.png" />
          </div>
        </div> 

        <div class="video-container">
          <h2 class="video-heading">Using Financeable with YourInsuranceHQ</h2>
          <video-player
            src="https://yourinsurancehq.com.au/wp-content/uploads/2026/08/financeable-overview-video-compressed-2.mp4"
          />
        </div>
      </div>
    </div>
    <TextFooter />
  </div>
</template>

<script>
import TextFooter from "../components/TextFooter.vue";
import VideoPlayer from "../components/VideoPlayer.vue";

export default {
  name: "FinanceableVideo",
  components: {
    TextFooter,
    VideoPlayer,
  },
};
</script>

<style scoped>
.login-logo {
  width: 100%;
  max-width: 350px;
}

.window-sizer {
  width: 100vw;
  max-width: 1900px;
}

.video-container {
  text-align: center;
  padding: 20px 0 40px;
}

.video-heading {
  color: black;
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
